<template>
	<nk-wrapper spacing="md">
		<nk-wrapper
			v-for="(group, buchstabeIndex) in groups"
			:key="`buchstabe-${buchstabeIndex}`"
			spacing="sm"
		>
			<nk-accordion
				:title="group.buchstabe"
				title-size="lg"
				:open="openAccordion(buchstabeIndex) || options.openAllAccordions"
			>
				<nk-row vertical-gutter="4" gutter="4">
					<nk-col
						v-for="(mitarbeiter, mitarbeiterIndex) in group.mitarbeiter"
						:key="`mitarbeiter-${mitarbeiterIndex}`"
						cols="full"
						md="6/12"
						xl="4/12"
					>
						<nk-card variant="boxed" :grouped="false">
							<template #header>
								<nk-link :link="mitarbeiter.detailURL">
									<nk-title tag="h3" size="md" no-margin>
										{{ mitarbeiter.nachname }},
										{{ mitarbeiter.vorname }}
									</nk-title>
								</nk-link>
							</template>
							<template #body>
								<nk-list variant="clean" class="-mt-6">
									<nk-list-item
										v-for="(amt, indexAemter) in mitarbeiter.aemter"
										:key="`indexAemter${indexAemter}`"
									>
										{{ amt.funktion }}
									</nk-list-item>
								</nk-list>
								<nk-address variant="vertical" v-bind="mitarbeiter.kontakt" />
							</template>
						</nk-card>
					</nk-col>
				</nk-row>
			</nk-accordion>
		</nk-wrapper>
	</nk-wrapper>
</template>

<script>
import {groupBy, sortBy, map} from 'lodash-es';
import TemplatesDefault from '../../mixins/templates-default';

/**
 * @prop {object} context.mitarbeiter
 * @prop {object} options
 * @prop {Boolean} options.openAllAccordions
 */
export default {
	name: 'NkTemplateMitarbeiterUebersicht',

	mixins: [TemplatesDefault],

	computed: {
		groups() {
			const result = this.context.mitarbeiter;
			return this.sortByLetters(result);
		},
	},

	methods: {
		sortByLetters(array) {
			const sortArray = sortBy(array, 'nachname');
			const groupArray = groupBy(sortArray, item =>
				item.nachname[0].toUpperCase(),
			);

			const mappedArray = map(groupArray, (value, key) => ({
				buchstabe: key,
				mitarbeiter: value,
			}));

			return mappedArray;
		},

		openAccordion(index) {
			if (this.options && typeof this.options.openAccordion !== 'undefined') {
				if (typeof this.options.openAccordion === 'boolean') {
					return this.options.openAccordion;
				}

				if (Number.isInteger(this.options.openAccordion)) {
					return this.options.openAccordion === index;
				}
			}
			return this.context.length === 1;
		},
	},
};
</script>
